import React from "react";
import "./PrivacyPolicy.scss";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div>
      <div className="PP-main">
        <div className="PP-outer">
          <div className="PP-part">
            <div className="PP-inner">
              <p>
                Thank you for choosing RAER for your online shopping needs. At
                RAER, we are committed to protecting your privacy and ensuring
                the security of your personal information. This Privacy Policy
                outlines how we collect, use, disclose, and safeguard your
                information when you visit our website or make a purchase from
                RAER.
              </p>
              <p>
                By accessing or using the RAER website, you agree to the terms
                of this Privacy Policy. If you do not agree with the terms of
                this policy, please do not use our website.
              </p>
            </div>
            <div className="PP-inner">
              <h1>1. Information We Collect:</h1>
              <h3>1.1. Personal Information:</h3>
              <ul className="b">
                <li>
                  When you visit our website, we may collect personal
                  information such as your name, email address, phone number,
                  billing address, and shipping address.
                </li>
              </ul>
              <h3>1.2. Payment Information:</h3>
              <ul className="b">
                <li>
                  To process your orders, we collect payment information,
                  including credit card details or other payment methods.
                </li>
              </ul>
              <h3>1.3. Automatically Collected Information:</h3>
              <ul className="b">
                <li>
                  We may collect information about your device, IP address,
                  browser type, and browsing patterns to improve our website and
                  user experience.
                </li>
              </ul>
            </div>
            <div className="PP-inner">
              <h1>2. How We Use Your Information:</h1>
              <h3>2.1. Order Processing:</h3>
              <ul className="b">
                <li>
                  We use your personal and payment information to process and
                  fulfill your orders.
                </li>
              </ul>
              <h3>2.2. Communication:</h3>
              <ul className="b">
                <li>
                  We may use your contact information to send order updates,
                  promotional offers, and other relevant communications.
                </li>
              </ul>
              <h3>2.3. Customer Support:</h3>
              <ul className="b">
                <li>
                  Your information may be used to provide customer support and
                  address inquiries.
                </li>
              </ul>
              <h3>2.4. Improving Our Services:</h3>
              <ul className="b">
                <li>
                  We analyze data to enhance our website, products, and
                  services, providing a better experience for our customers.
                </li>
              </ul>
            </div>
            <div className="PP-inner">
              <h1>3. How We Protect Your Information:</h1>
              <h3>3.1. Data Security:</h3>
              <ul className="b">
                <li>
                  We implement security measures to protect your personal
                  information from unauthorized access, disclosure, alteration,
                  and destruction.
                </li>
              </ul>
              <h3>3.2. Secure Transactions:</h3>
              <ul className="b">
                <li>
                  We use industry-standard encryption for secure online
                  transactions.
                </li>
              </ul>
            </div>
            <div className="PP-inner">
              <h1>4. Information Sharing:</h1>
              <h3>4.1. Third-Party Services:</h3>
              <ul className="b">
                <li>
                  We may share your information with trusted third-party
                  services, such as payment processors and shipping partners, to
                  fulfill your orders.
                </li>
              </ul>
              <h3>4.2. Legal Compliance:</h3>
              <ul className="b">
                <li>
                  We may disclose your information to comply with legal
                  obligations or protect our rights.
                </li>
              </ul>
            </div>
            <div className="PP-inner">
              <h1>5. Contact Us:</h1>
              <p>
                If you have any questions, concerns, or requests regarding this
                Privacy Policy, please contact us at
                raerofficialclothing@gmail.com.
              </p>
              <p>
                By using the RAER website, you acknowledge that you have read
                and understand this Privacy Policy and consent to the practices
                described herein.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
